<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="title">Maggie</h1>
<h2 class="author">M. C. Beaton/ Marion Chesney</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795319587_epub_tp_r1.vue?64e09090